import React from "react";
import { Box, Skeleton, useTheme } from "@mui/material";

// Shared loading placeholder for the Dashboard's row-list cards (ContactsPanel now,
// TeamMembersPanel/others later — same avatar+2-line-left+2-line-right row shape across
// all of them). Mirrors each real row's own layout constants (gap 1.6, py 1.7, divider)
// so the list doesn't jump in height once real rows replace it — same "shape-matched
// skeleton" convention already used in the Tasks module tables (TasksListTable.jsx etc.),
// just factored into one component since this shape repeats across cards instead of columns.
function DashboardRowSkeleton({ count = 5, avatarSize = 43 }) {
  const theme = useTheme();
  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <Box
          key={i}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.6,
            py: 1.7,
            borderBottom: i !== count - 1 ? `1px solid ${theme.palette.divider}` : "none",
          }}
        >
          <Skeleton variant="circular" width={avatarSize} height={avatarSize} sx={{ flexShrink: 0 }} />
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Skeleton variant="text" width="55%" height={20} />
            <Skeleton variant="text" width="75%" height={18} sx={{ mt: 0.25 }} />
          </Box>
          <Box sx={{ flexShrink: 0 }}>
            <Skeleton variant="text" width={60} height={16} sx={{ ml: "auto" }} />
            <Skeleton variant="text" width={70} height={16} sx={{ mt: 0.375, ml: "auto" }} />
          </Box>
        </Box>
      ))}
    </>
  );
}

export default DashboardRowSkeleton;
